import React from "react";
import {CheckoutTotals} from "../components";
import useCartState from "src/core/checkout/hooks/useCartState";
import useCartErrors from "../../hooks/useCartErrors";

function CartTotals(props) {
  const [cartState] = useCartState();
  const cart = cartState.data;
  const [cartErrors] = useCartErrors();
  const isValid = !cartErrors || !cartErrors.length;

  if (cart) {
    return (
      <CheckoutTotals
        {...cart.getPrices()}
        taxDetails={cart.getTaxDetails()}
        isValid={isValid}
        discounts={cart.getDiscounts()}
        hasDiscount={cart.hasDiscount()}
        {...props}
      />
    );
  } else {
    return null;
  }
}

export default CartTotals;
